var _path, _path2, _path3, _path4, _rect, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailedPersonalityDisable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "#9ca3af",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.5,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7V5a2 2 0 0 1 2-2h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3h2a2 2 0 0 1 2 2v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17v2a2 2 0 0 1-2 2h-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H5a2 2 0 0 1-2-2v-2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 8,
    height: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10a2 2 0 1 1 4 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedPersonalityDisable);
export default __webpack_public_path__ + "static/media/detailed_personality_disable.1ebd77f18f3f0be2e97b4a2a1e4df3c3.svg";
export { ForwardRef as ReactComponent };